// extracted by mini-css-extract-plugin
export default {"searchIcon":"MainContactSearch_searchIcon__5MicO"};